import { styled } from '@linaria/react';
import { useSpring, animated } from 'react-spring';

import Wrapper from './Wrapper';

function EnablePerspectiveDemo({ enablePerspective }) {
  return (
    <Wrapper
      style={{
        perspective:
          enablePerspective === 'true' ? '250px' : undefined,
      }}
    >
      <Box />
    </Wrapper>
  );
}

const Box = styled.div`
  width: 120px;
  height: 120px;
  background: var(--color-primary);
  animation: boxSpin 4000ms ease-in-out infinite;
  will-change: transform;

  @keyframes boxSpin {
    0% {
      transform: rotateY(0deg) translate3d(0px, 0px, 0px);
    }
    25% {
      transform: rotateY(45deg) translate3d(0px, 0px, 0px);
    }
    50% {
      transform: rotateY(0deg) translate3d(0px, 0px, 50px);
    }
    75% {
      transform: rotateY(0deg) translate3d(0px, 0px, -100px);
    }
  }
`;

export default EnablePerspectiveDemo;
